import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectPackages = (state: RootState) => state.package;

export const selectBundleProductsSelector = createSelector(
  selectPackages,
  (packages) => packages.bundleProducts.items
);

export const selectVirtualProductsSelector = createSelector(
  selectPackages,
  (packages) => packages.virtualProducts.items
);
